import { isChunkLoadError } from '#utils/isChunkLoadError';

type SentryEventLike = {
  level?: string;
  tags?: Record<string, unknown>;
  fingerprint?: string[];
  exception?: { values?: { value?: string; type?: string }[] };
};

export const CHUNK_ERROR_FINGERPRINT = 'chunk-load-error';

/**
 * Сводит все падения протухшего чанка в одну группу.
 *
 * Без этого одна и та же поломка размазана по десяткам issue: кадр стека указывает на
 * `/assets/lazyRouteComponent-<хеш>.js`, а хеш свой у каждого релиза — плюс три движка пишут её
 * тремя разными фразами. Считать по такому «сколько было и стало» невозможно, а именно это и
 * нужно, чтобы понять, помогла ли починка.
 *
 * Событие не выбрасываем: протухший чанк — настоящая проблема, просто не аварийного уровня, и
 * пропасть из телеметрии он не должен.
 */
export const groupChunkErrorEvent = <TEvent extends SentryEventLike>(
  event: TEvent,
  hint?: { originalException?: unknown }
): TEvent => {
  const message = event.exception?.values?.[0]?.value;

  if (!isChunkLoadError(hint?.originalException) && !isChunkLoadError(message)) {
    return event;
  }

  event.level = 'warning';
  event.fingerprint = [CHUNK_ERROR_FINGERPRINT];
  event.tags = { ...event.tags, chunk_load_error: true };

  return event;
};
